'use strict'

import axios from 'axios'

const baseUrl = '/api/v2/me'

export default class General {
  /**
   * @param  {*} values
   * @param  {*} callback
   * @return {*} callback
   */
  static retrieveJadlogAgencies (params, callback) {
    axios.get(`${baseUrl}/shipment/agencies?company=2&status=available`, { params }).then(response => callback(response))
  }
}
